<!--
    @修改人：黎柏祺
    @修改时间：2018-10-24
    @修改描述：框架升级
    @版本:v1.0.26
    --------
    @修改人：谢汉
    @修改时间：2018-07-06
    @修改描述：改版主机地图
    @版本:v1.0.18
    --------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 主机地图详情页
-->
<template>
  <div class="hostMonitorDetail__content">
    <back :history="history"></back>
    <div>
      <div class="siteName">{{ siteName }}</div>
      <div class="siteInfo">
        <div>
          <span v-text="$t('hostMapping.siteCode') + '：' + siteCode" class="mr50 lock-width"></span>
          <span v-text="$t('hostMapping.total') + '：' + totalHostNum"></span>
        </div>
        <div>
          <span v-text="$t('hostMapping.network') + '：' + network" class="mr50 lock-width"></span>
          <span v-text="$t('hostMapping.powerOn') + '：' + totalPowerOnNum" class="mr100"></span>
          <span v-text="$t('hostMapping.powerOff') + '：' + totalPowerOffNum"></span>
        </div>
      </div>
      <div class="siteName">{{$t('hostMapping.instanceType')}}</div>
      <div class="powerInfo" v-for="(item,index) in instanceTypeGroupList" :key="'key'+index">
        <div>
          <span v-text="$t('hostMapping.powerOn') + '：' + item.powerOn" class="power power-on mr40"></span>
          <span v-text="$t('hostMapping.powerOff') + '：' + item.powerOff" class="power power-off"></span>
        </div>
        <div>
          <span v-text="item.instanceType"></span>
        </div>
      </div>
      <div v-show="instanceTypeGroupList.length == 0" style="text-align: center;">{{$t('hostMapping.noData')}}</div>
      <div class="siteName">{{$t('hostMapping.department')}}</div>
      <div class="powerInfo" v-for="(item,index) in moduleGroupList" :key="index">
        <span class="powerInfo-check" @click="checkDepartment(item)">{{$t('hostMapping.check')}}</span>
        <div>
          <span v-text="$t('hostMapping.powerOn') + '：' + item.powerOn" class="power power-on mr40"></span>
          <span v-text="$t('hostMapping.powerOff') + '：' + item.powerOff" class="power power-off"></span>
        </div>
        <div>
          <span v-text="item.department"></span>
        </div>
      </div>
      <div v-show="moduleGroupList.length == 0" style="text-align: center;">{{$t('hostMapping.noData')}}</div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import hostMappingBiz from '@/logic/intelligentMonitor/hostMappingBiz.js'
  import back from '@/components/back.vue'

  export default {
    components: {
      back: back
    },
    data () {
      return {
        lan: {},
        history: [],
        siteCode: '',
        siteName: '',
        network: '',
        totalHostNum: 0,
        totalPowerOnNum: 0,
        totalPowerOffNum: 0,
        instanceTypeGroupList: [],
        moduleGroupList: []
      }
    },
    watch: {
      '$route': function (newValue, oldValue) {
        if (newValue.name === 'hostMappingDetail') {
          this.e_init()
        }
      },
      siteCode () {
        this.e_getSiteInfo()
        this.setHistory()
      }
    },
    methods: {
      e_reset () {
        this.instanceTypeGroupList = []
        this.moduleGroupList = []
      },
      e_getSiteInfo () {
        this.e_reset()
        hostMappingBiz.getRegionMap({ siteCode: this.siteCode }).then((data) => {
          this.siteName = data.siteName
          this.setHistory(this.siteName)
          if (data.network) {
            this.network = data.network
          }
          this.instanceTypeGroupList = data.instanceTypeGroupList
          this.moduleGroupList = data.moduleGroupList
          this.totalHostNum = data.total
          this.totalPowerOnNum = data.powerOn
          this.totalPowerOffNum = data.powerOff
        })
      },
      setHistory (siteName) {
        this.history = []
        siteName ? this.history.splice(0, 1, { name: siteName }) : this.history.push({ name: '' })
      },
      checkDepartment (item) {
        this.$router.push({ path: '/home/hostMapping/hostMappingModule', query: { siteCode: this.siteCode, department: item.department } })
      },
      e_init () {
        this.siteCode = this.$route.query.siteCode
      }
    },
    mounted () {
      this.e_init()
    }
  }
</script>
<style scoped>
  .hostMonitorDetail__content{
      font-size: 14px;
  }
  .hostMonitorDetail__content .noData {
      height: 150px;
      line-height: 150px;
  }
  .hostMonitorDetail__content .siteName {
      font-size: 20px;
      font-weight: bolder;
  }
  .hostMonitorDetail__content .siteInfo {
      padding: 18px;
  }
  .hostMonitorDetail__content .lock-width {
      display: inline-block;
      width: 200px;
  }
  .hostMonitorDetail__content .powerInfo {
      display: inline-block;
      width: 254px;
      height: 100px;
      padding: 24px 8px;
      line-height: 28px;
      margin: 10px;
      border: 1px solid #ddd;
      border-radius: 2px;
      text-align: center;
      position: relative;
      box-sizing: border-box;
      vertical-align: top;
  }
  .hostMonitorDetail__content .powerInfo .powerInfo-check {
      color: #3385ff;
      float: right;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 2px;
      display: none;
  }
  .hostMonitorDetail__content .powerInfo:hover .powerInfo-check{
      display: block;
  }
  .hostMonitorDetail__content .power {
      font-size: 18px;
      font-weight: bolder;
  }
  .hostMonitorDetail__content .power-on {
      color: #1db50c;
  }
  .hostMonitorDetail__content .power-off {
      color: rgba(195, 195, 195, 0.91);
  }
  .hostMonitorDetail__content .mr40 {
      margin-right: 40px;
  }
  .hostMonitorDetail__content .mr50 {
      margin-right: 50px;
  }
  .hostMonitorDetail__content .mr100 {
      margin-right: 100px;
  }
</style>